import React from "react";

export type DropdownItemProps = {
  children: JSX.Element | JSX.Element[] | string;
  className?: string;
  onClick?: () => void;
  parentOnClick?: (e: React.MouseEvent<HTMLDivElement, MouseEvent> | React.KeyboardEvent<HTMLDivElement>) => void;
};

export const DropdownItem = ({ children, className = "", onClick, parentOnClick }: DropdownItemProps): JSX.Element => {
  const handleActivate = (
    e: React.MouseEvent<HTMLDivElement, MouseEvent> | React.KeyboardEvent<HTMLDivElement>
  ): void => {
    if (parentOnClick) parentOnClick(e);
    else e.stopPropagation();
    if (onClick) onClick();
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>): void => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      handleActivate(e);
    }
  };

  return (
    <div
      className={`DropdownItem body1 ${className}`}
      role="button"
      tabIndex={0}
      onClick={handleActivate}
      onKeyDown={handleKeyDown}
    >
      {children}
    </div>
  );
};
